/**
 * Created by esenckewitch on 19.03.2026.
 */

const OKBridgeAds = function () {
    VKAds.call(this, connector.OKBRIDGE);
};

OKBridgeAds.prototype = Object.create(VKAds.prototype);
OKBridgeAds.prototype.constructor = OKBridgeAds;

OKBridgeAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.OKBRIDGE);
};
